<template>
    <div>
        <div class="content-box first">
            <div class="album-info">
                <el-image :src="$utils.coverImg(albumShare.cover, 200, 200)"
                    :preview-src-list="[$utils.coverImg(albumShare.cover)]" fit="cover">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
                <div class="info">
                    <div class="title">{{ albumShare.name }}</div>
                    <div class="artist">{{ albumShare.artist }}</div>
                    <el-button @click="visible = true" type="primary">分享音乐</el-button>
                </div>
            </div>
        </div>
        <div class="sp-list">
            <div class="title">
                大陆主要平台
                <span>提供全球200+平台渠道上线服务</span>
            </div>
            <div v-if="albumShare.domesticSpLinks && albumShare.domesticSpLinks.length > 0" class="rows">
                <div class="item" v-for="(item, index) in albumShare.domesticSpLinks" :key="index">
                    <el-image :src="$utils.coverImg(item.spLogo, 100, 100)" fit="cover">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div class="info">
                        <h3>{{ item.spName }}</h3>
                        <p v-if="item.link">已上线至该音乐平台</p>
                        <p v-else>敬请期待</p>
                    </div>
                    <el-button type="primary" :disabled="item.link ? false : true" @click="openWin(item.link)"
                        plain>播放</el-button>
                </div>
            </div>
            <el-empty v-else description="暂无大陆平台数据"></el-empty>
        </div>
        <div class="sp-list" style="margin-bottom: 40px">
            <div class="title">
                海外主要平台
                <span>非大陆地区，播放链接可能无法打开</span>
            </div>
            <div v-if="albumShare.foreignSpLinks && albumShare.foreignSpLinks.length > 0" class="rows">
                <div class="item" v-for="(item, index) in albumShare.foreignSpLinks" :key="index">
                    <el-image :src="$utils.coverImg(item.spLogo, 50, 50)" fit="cover">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div class="info">
                        <h3>{{ item.spName }}</h3>
                        <p v-if="item.link">已上线至该音乐平台</p>
                        <p v-else>敬请期待</p>
                    </div>
                    <el-button type="primary" :disabled="item.link ? false : true" @click="openWin(item.link)"
                        plain>播放</el-button>
                </div>
            </div>
            <el-empty v-else description="暂无海外平台数据"></el-empty>
        </div>
        <share-image :visible.sync="visible" :album="albumShare"></share-image>
    </div>
</template>

<script>
import ShareImage from '../components/ShareImage';
export default {
    data() {
        return {
            albumShare: {
                domesticSpLinks: [],
                foreignSpLinks: [],
            },
            visible: false,
        };
    },
    components: {
        ShareImage,
    },
    computed: {},
    mounted() {
        this.getSplink();
    },
    methods: {
        async getSplink() {
            const { albumId } = this.$route.params;
            const { id } = this.$route.query;
            const response = await this.$request({
                url: '/newAlbum/splink',
                method: 'GET',
                params: { id: id || albumId },
            });
            const { state, msg, result } = response.data;
            if (!state) return this.$message.error(msg || '请求失败');
            this.albumShare = result;
        },
        openWin(link) {
            window.open(link);
        },
    },
};
</script>

<style lang="scss" scoped>
.album-info {
    position: relative;
    height: 220px;
    margin-top: 20px;
    width: 100%;

    .el-image {
        float: left;
        width: 200px;
        height: 200px;
    }

    .info {
        position: absolute;
        left: 230px;
        height: 200px;

        .title {
            font-size: 28px;
            font-weight: 600;
            color: #000000;
            line-height: 28px;
        }

        .artist {
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            line-height: 14px;
            margin-top: 20px;
        }

        .el-button {
            position: absolute;
            bottom: 0px;
            left: 0px;
            box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
            border-radius: 42px;
            color: #fff;
            border: none;
        }
    }
}

.sp-list {
    margin-top: 20px;
    background: #ffffff;
    border-radius: 10px;
    padding: 40px 30px;

    .title {
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        line-height: 18px;
        margin-bottom: 10px;

        span {
            font-weight: 400;
            color: #909399;
            font-size: 12px;
            margin-left: 20px;
        }
    }

    .rows {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 20px;

        .item {
            padding: 30px;
            position: relative;
            background: #f6f5fa;
            border-radius: 4px;
            height: 110px;
            margin-top: 20px;

            .el-image {
                float: left;
                width: 50px;
                height: 50px;
            }

            .info {
                position: absolute;
                left: 100px;
                height: 50px;

                h3 {
                    font-size: 16px;
                    font-weight: 600;
                    color: #000000;
                    line-height: 16px;
                    margin-top: 5px;
                }

                p {
                    font-size: 12px;
                    font-weight: 400;
                    color: #909399;
                    line-height: 12px;
                    margin-top: 12px;
                }
            }

            .el-button {
                position: absolute;
                right: 30px;
                top: 35px;

                &.is-disabled {
                    opacity: 0.5;
                }
            }
        }
    }
}
</style>
